import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import { BrandMapping, Images } from '@nsw-paginas-deslogadas/assets'
import { Box, Button } from '@dasa-health/components-react'
import Topic, { TopicItemProps } from '../Topic'
import * as S from './styles'

const FoldPagePresentationProduct: React.FC = () => {
    const { mapping, brand: brand_, product } = useAppContext()
    const brand = BrandMapping[brand_.mappingId]

    const { PersonWithChild } = Images

    const [seeMore, setSeeMore] = useState(false)
    const [countLines, setCountLines] = useState(0)

    const price = useMemo(
        () => product?.lowestPriceBrand?.find(lp => lp.brandId === brand.id)?.price,
        [brand.id, product?.lowestPriceBrand],
    )

    const synonymies = useMemo(() => product.synonymies?.join(', '), [product.synonymies])

    const productLabel = useMemo(() => `Agendar ${product.category?.id === 4 ? 'vacina' : 'exame'}`, [product])

    const dataAtributtes = useMemo(
        () => ({
            'data-item-position': 'Main Hero',
            'data-current-service': 'Página de Produto da Marca',
            'data-item-text': productLabel,
        }),
        [productLabel],
    )

    const items: TopicItemProps[] = [
        {
            icon: 'Clock',
            text: `Agendando seus exames ${mapping.vaccine ? 'e vacinas' : ''} online, você é atendido mais rapidamente.`,
            title: 'Atendimento rápido',
        },
        {
            icon: 'Calendar',
            text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
            title: 'Liberdade de agendamento',
        },
        {
            icon: 'HealthInsurace',
            text: `${
                product.category?.id === 4 ? 'Vacina' : 'Exame'
            } possui cobertura ANS. Verifique se o procedimento é coberto pelo seu plano de saúde.`,
            title: 'Possui cobertura',
        },
    ]

    const itemsWithoutANS: TopicItemProps[] = [
        {
            icon: 'Clock',
            text: `Agendando seus exames ${mapping.vaccine ? 'e vacinas' : ''} online, você é atendido mais rapidamente.`,
            title: 'Atendimento rápido',
        },
        {
            icon: 'Calendar',
            text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
            title: 'Liberdade de agendamento',
        },
    ]

    const PredictionTag: React.FC = () => {
        const getMessageFormated = () => {
            const deadlineHours = product.deadline?.deadlineHours || 0

            if (deadlineHours < 24) {
                return deadlineHours <= 1 ? `1 hora` : `${deadlineHours} horas`
            }

            const days = Math.round(deadlineHours / 24) || 1
            return days <= 1 ? `1 dia` : `${days} dias`
        }

        return (
            <>
                {product.deadline?.deadlineHours && <S.PredictionTag>Resultado em até {getMessageFormated()}</S.PredictionTag>}
                {product.coverageAns && <S.PredictionTag>Coberto por convênios</S.PredictionTag>}
            </>
        )
    }

    const calcTextSynonymies = useCallback(() => {
        const textSynonymies = document.getElementById('text-synonymies')
        if (textSynonymies) {
            const { height } = textSynonymies.getBoundingClientRect()
            const textSynonymiesLineHeight = textSynonymies.style.lineHeight

            const countLines = height / Number(textSynonymiesLineHeight.replace('px', ''))
            setCountLines(countLines)
        }
    }, [])

    useEffect(() => {
        calcTextSynonymies()
    }, [calcTextSynonymies])

    return (
        <>
            <S.Container>
                <S.GridLayout>
                    <S.BoxTexts>
                        <S.TextBrand>NO {brand.name.toLocaleUpperCase()}</S.TextBrand>
                        <S.Title>{product.name}</S.Title>
                        <S.SubTitle
                            id={'text-synonymies'}
                            open={seeMore || countLines === 0}
                            shouldShowFade={countLines > 2 && !seeMore}
                            style={{ lineHeight: '24px' }}
                        >
                            {`Também conhecido como: ${synonymies}`}
                        </S.SubTitle>
                        {countLines > 2 && (
                            <S.SeeMore aria-hidden="true" onClick={() => setSeeMore(!seeMore)}>
                                {`veja ${seeMore ? 'menos' : 'mais'}`}
                            </S.SeeMore>
                        )}
                        {product.coverageAns && !!product.deadline?.deadlineHours && (
                            <S.TagContainer>
                                <PredictionTag />
                            </S.TagContainer>
                        )}
                        {price && (
                            <S.Price>
                                a partir de <em>R${price}</em>
                            </S.Price>
                        )}
                    </S.BoxTexts>
                    <S.ButtonGrid>
                        <S.ButtonsBox>
                            <a href={product.navigateTo} target="_self" {...dataAtributtes}>
                                <Button data-testid="btn-exams">{productLabel}</Button>
                            </a>
                        </S.ButtonsBox>
                    </S.ButtonGrid>
                    <S.ImageGrid>
                        <Box>
                            <S.Img alt={PersonWithChild.alt} src={PersonWithChild.src} />
                        </Box>
                    </S.ImageGrid>
                </S.GridLayout>

                <S.TopicBox>
                    <Topic.Group items={product.coverageAns ? items : itemsWithoutANS} />
                </S.TopicBox>
            </S.Container>
        </>
    )
}

export default FoldPagePresentationProduct
